module.exports = __webpack_public_path__ + "img/Canceled.16cbdf24.png";